import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/car/us/a-sticky-header-check-our-prices';
import { CarPageTemplate } from '@/pageTemplate/CarPageTemplate';
import { useEffect } from 'react';

export default function CarPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('car_page.viewed', {
        experiment: 'a-sticky-header-check-our-prices',
      }),
    [],
  );

  return <CarPageTemplate config={config} isNjEnabled={false} />;
}
